<template>
  <Flex>
    <Flex>
      <input
        type="checkbox"
        class="checkbox"
        :checked="isCurrentMeasure()"
        :disabled="isOnlySelectedMeasure()"
        @change="onMeasureCheck($event)"
      />
      <label class="measure-link" @click="selectOnlyThisMeasure()">{{ $t(measure.name) }} </label>
    </Flex>
    <DropDown :options="measure.subOptions" @updateOption="onSubOptionUpdate" />
  </Flex>
</template>

<script>
import { mapState } from 'vuex'
import Flex from '@wizer/core/components/flex/Flex'
import { compact, isEqual, sortBy } from 'lodash'
import DropDown from '@/components/DropDown'

export default {
  name: 'MeasureMultiSelector',
  components: {
    Flex,
    DropDown,
  },
  props: {
    measure: Object,
  },
  data() {
    return {
      showMenu: false,
      selectedSubOption: this.measure.subOptions[0],
    }
  },
  computed: {
    ...mapState({
      allMeasures: (state) => state.ChartCategory.measures,
    }),
  },
  methods: {
    onMeasureCheck(event, updateSelectedMeasure) {
      let newMeasures = [].concat(this.$route.query.measures)
      if (this.isCurrentMeasure()) {
        newMeasures = newMeasures.filter((measure) => {
          return this.measure.attributePath !== this.measureAttribute(measure)
        })
      }
      if (updateSelectedMeasure || !this.isCurrentMeasure()) {
        newMeasures = newMeasures.concat(this.getMeasureText())
      }
      this.loadNewMeasures(newMeasures, this.$route.query.calculatedMeasures)
    },
    getMeasureText() {
      const measureFunction = this.selectedSubOption?.attributeValue || 'count'
      return `${measureFunction}(${this.measure.attributePath})`
    },
    loadNewMeasures(newMeasures, calculatedMeasures) {
      const route = this.getRoute(this.getSortedMeasures(newMeasures), calculatedMeasures)
      if (!isEqual(this.$route.query, route.query)) {
        this.$router.push(route)
      }
    },
    selectOnlyThisMeasure() {
      this.loadNewMeasures([this.getMeasureText()], [])
    },
    getSortedMeasures(newMeasures) {
      const attributePaths = this.allMeasures.map((measure) => {
        return measure.attributePath
      })
      return sortBy(newMeasures, (measure) =>
        attributePaths.indexOf(this.measureAttribute(measure)),
      )
    },
    onSubOptionUpdate(newSubOption) {
      this.selectedSubOption = newSubOption
      this.onMeasureCheck(null, true)
    },
    getRoute(newMeasures, calculatedMeasures) {
      const combinedMeasures = compact([].concat(newMeasures).concat(calculatedMeasures))
      let selectedSeries = this.$route.query.selectedSeries
      if (combinedMeasures.length > 1) {
        selectedSeries = ''
      }
      const route = {
        name: this.$route.name,
        query: {
          ...this.$route.query,
          measures: newMeasures,
          calculatedMeasures,
          selectedSeries,
        },
      }
      return route
    },
    measureAttribute(fullMeasure) {
      if (fullMeasure && fullMeasure.length > 0) {
        return fullMeasure.substring(fullMeasure.indexOf('(') + 1, fullMeasure.indexOf(')'))
      }
      return null
    },
    isCurrentMeasure() {
      return [].concat(this.$route.query.measures).some((measure) => {
        return this.measure.attributePath === this.measureAttribute(measure)
      })
    },
    isOnlySelectedMeasure() {
      const combinedMeasures = compact(
        [].concat(this.$route.query.measures).concat(this.$route.query.calculatedMeasures),
      )
      return this.isCurrentMeasure() && combinedMeasures.length === 1
    },
  },
}
</script>

<style lang="postcss" scoped>
.measure-link {
  @apply break-words pl-2 cursor-pointer text-primary-500;
}
.checkbox {
  margin-top: 0.1rem;
  cursor: pointer;
}
</style>
